import { Text, Stack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Skeleton } from 'native-base';
import React from 'react';

import { DownloadButton } from './components/DownloadButton';

const loadingData = [
  {
    title: 'Ult. Atualização',
    maxW: { base: 'full', sm: '124px' },
  },
  {
    title: 'Tipo de solicitação',
    maxW: { base: 'full', sm: '113px' },
  },
  {
    title: 'Status',
    maxW: { sm: '220px', lg: '110px' },
  },
];

export const SpreadsheetLoadingRequestItem = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  return (
    <Stack
      direction={{ base: 'column', sm: 'row' }}
      w="full"
      flex={1}
      alignItems="center"
      justifyContent="space-between"
      space={{ base: Spacing['inline.nano'], sm: 0 }}
      py={Spacing['stack.xxxs']}>
      {loadingData.map((item) => (
        <Stack
          key={item.title}
          direction={{ base: 'row', sm: 'column' }}
          w="full"
          maxW={item.maxW}
          alignItems={{ sm: 'flex-start', base: 'center' }}
          justifyContent="space-between"
          space={Spacing['stack.nano']}>
          <Text variant={{ base: 'regular', sm: 'semibold' }} color="neutral.black">
            {item.title}
          </Text>
          <Skeleton
            w="full"
            {...(isMobile && { flex: 0.5 })}
            h={Spacing['inline.xxxs']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </Stack>
      ))}
      <DownloadButton isDisabled />
    </Stack>
  );
};
